import { isNil } from "lodash";
import { useCallback, useState } from "react";
import { WootingCDN } from "../../utils/constants/openGraph";
import { useDiscordUser } from "../../utils/hooks/useDiscordUser";

export default function ProfileImage({ isHovered }: { isHovered?: boolean }) {
  const { user } = useDiscordUser();
  const [isHovering, setIsHovered] = useState(false);
  const onMouseEnter = useCallback(() => setIsHovered(true), [setIsHovered]);
  const onMouseLeave = useCallback(() => setIsHovered(false), [setIsHovered]);
  const doAnimate = isHovered || isHovering;

  return (
    <img
      src={
        !isNil(user)
          ? formatAvatarURL(user.displayAvatarURL, doAnimate)
          : WootingCDN.defaultProfile
      }
      alt="profile image"
      className="size-30 rounded-full border border-outline-primary bg-container-primary object-cover"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
}

function formatAvatarURL(url: string, doAnimate: boolean) {
  // This is the format of the discord avatar URL taken from their official "wumpus" example account
  // https://cdn.discordapp.com/avatars/47835198259242069/c1f86b313385cb97985f1b118851c28c.webp?size=256
  // https://cdn.discordapp.com/avatars/47835198259242069/c1f86b313385cb97985f1b118851c28c.png?size=256
  return url.replace(doAnimate ? ".png" : "", "");
}
